var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "modal-benefit-setting",
      "title": "新增權益"
    }
  }, [_vm.isLoading ? _c('div', {
    staticClass: "text-center mt-3 mb-3 loading-spinner"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "secondary",
      "small": ""
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "mt-3 mb-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*名稱"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.tab_name.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.tab_name,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "tab_name", $$v);
      },
      expression: "localBenefitSetting.tab_name"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.tab_name.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*路徑"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.path.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.path,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "path", $$v);
      },
      expression: "localBenefitSetting.path"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.path.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "*順序"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.order.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.order,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "order", $$v);
      },
      expression: "localBenefitSetting.order"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.order.$invalid
    }
  }, [!_vm.$v2.localBenefitSetting.order.$pending && _vm.$v2.localBenefitSetting.order.$errors.some(function (e) {
    return e.$validator === 'required';
  }) ? _c('span', [_vm._v(" 此欄位為必填 ")]) : _vm._e(), !_vm.$v2.localBenefitSetting.order.$pending && _vm.$v2.localBenefitSetting.order.$errors.some(function (e) {
    return e.$validator === 'numeric';
  }) ? _c('span', [_vm._v(" 此欄位必須是數字 ")]) : _vm._e()])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "圖片"
    }
  }, [_c('button', {
    staticClass: "btn btn-link px-2 text-dark align-self-start upload-button"
  }, [_c('b-form-file', {
    attrs: {
      "accept": "image/*",
      "placeholder": "尚未選擇檔案",
      "browse-text": "瀏覽"
    },
    on: {
      "change": function change($event) {
        return _vm.upload($event);
      }
    }
  }), _vm.localBenefitSetting.tab_image ? _c('a', {
    staticClass: "btn-sm btn-outline-danger",
    on: {
      "click": _vm.handleDelete
    }
  }, [_c('i', {
    staticClass: "fa fa-trash-o"
  })]) : _vm._e(), _c('a', {
    staticStyle: {
      "word-break": "break-all"
    },
    attrs: {
      "href": _vm.localBenefitSetting.tab_image,
      "target": "_blank"
    }
  }, [_c('small', [_vm._v(" " + _vm._s(_vm.displayText('upload_file.field_upload_file_current_path', '目前路徑')) + "：" + _vm._s(_vm.localBenefitSetting.tab_image || _vm.displayText('upload_file.field_upload_file_not_uploaded', '未上傳')) + " ")])])], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.tab_image.$error
    }
  }, [_vm._v(" " + _vm._s(_vm.displayText('upload_file.validation_required', '此欄位為必填')) + " ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "主標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.form_title.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "form_title", $$v);
      },
      expression: "localBenefitSetting.form_title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.form_title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "副標題"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.form_desc.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "form_desc", $$v);
      },
      expression: "localBenefitSetting.form_desc"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.form_desc.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "說明內容"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.content.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.content,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "content", $$v);
      },
      expression: "localBenefitSetting.content"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.content.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "立即使用按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.use_now_button_text.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.use_now_button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "use_now_button_text", $$v);
      },
      expression: "localBenefitSetting.use_now_button_text"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.use_now_button_text.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預設按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.button_text.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "button_text", $$v);
      },
      expression: "localBenefitSetting.button_text"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.button_text.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預設按鈕動作"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.button_action.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "button_action", $$v);
      },
      expression: "localBenefitSetting.button_action"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.button_action.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "預設按鈕網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.button_url.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "button_url", $$v);
      },
      expression: "localBenefitSetting.button_url"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.button_url.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "延伸按鈕文字"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.tab_button_text.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.tab_button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "tab_button_text", $$v);
      },
      expression: "localBenefitSetting.tab_button_text"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.tab_button_text.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "延伸按鈕動作"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.tab_button_action.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.tab_button_action,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "tab_button_action", $$v);
      },
      expression: "localBenefitSetting.tab_button_action"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.tab_button_action.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "延伸按鈕網址"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.$v2.localBenefitSetting.tab_button_url.$error ? false : null
    },
    model: {
      value: _vm.localBenefitSetting.tab_button_url,
      callback: function callback($$v) {
        _vm.$set(_vm.localBenefitSetting, "tab_button_url", $$v);
      },
      expression: "localBenefitSetting.tab_button_url"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.$v2.localBenefitSetting.tab_button_url.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "d-flex align-items-center justify-content-between mb-3"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.modal-search-coupon",
      modifiers: {
        "modal-search-coupon": true
      }
    }],
    staticClass: "flex-shrink-0 mr-2",
    attrs: {
      "variant": "inverse-primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("選擇優惠券")])], 1), _c('b-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.coupon && Object.keys(_vm.coupon).length > 0,
      expression: "coupon && Object.keys(coupon).length > 0"
    }],
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": [_vm.coupon],
      "fields": _vm.couponFields
    },
    scopedSlots: _vm._u([{
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'RedeemCodeBundleEdit',
              params: {
                redeemCodeBundleId: data.item.id
              }
            }
          }
        }, [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'name')))])])];
      }
    }, {
      key: "cell(img_url)",
      fn: function fn(data) {
        return [_vm.deepGet(data.item, 'img_url') ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": _vm.deepGet(data.item, 'img_url'),
            "alt": "圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.deepGet(data.item, 'quantity')))])];
      }
    }, {
      key: "cell(dateline_type)",
      fn: function fn(data) {
        return [_c('div', [_vm.deepGet(data.item, 'dateline_type') === 0 ? _c('span', [_vm._v("自定日期區間")]) : _vm.deepGet(data.item, 'dateline_type') === 1 ? _c('span', [_vm._v("依日期區間推算")]) : _vm.deepGet(data.item, 'dateline_type') === 2 ? _c('span', [_vm._v("與優惠券的領取期限相同")]) : _vm.deepGet(data.item, 'dateline_type') === 3 ? _c('span', [_vm._v("與此權益卡期限相同")]) : _vm.deepGet(data.item, 'dateline_type') === 4 ? _c('span', [_vm._v("與會員會籍期限相同")]) : _vm.deepGet(data.item, 'dateline_type') === 5 ? _c('span', [_vm._v("每月到期(當月1日起)")]) : _vm.deepGet(data.item, 'dateline_type') === 6 ? _c('span', [_vm._v("每月到期(自會籍起始日起)")]) : _c('span', [_vm._v("其他")])])];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_c('div', [_vm._v(_vm._s(_vm.formatDate(_vm.deepGet(data.item, 'created_at'))))])];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_c('b-button', {
          directives: [{
            name: "b-modal",
            rawName: "v-b-modal.modal-edit-quantity",
            modifiers: {
              "modal-edit-quantity": true
            }
          }],
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-info"
          },
          on: {
            "click": function click($event) {
              return _vm.editCoupon(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-settings"
        }), _vm._v(" 設定 ")]), _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": _vm.deleteCoupon
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 移除 ")])];
      }
    }])
  }), _c('SearchCoupon', {
    attrs: {
      "selectedCoupon": _vm.coupon
    },
    on: {
      "submit": _vm.handleCouponSubmit
    }
  }), _c('b-modal', {
    attrs: {
      "id": "modal-edit-quantity",
      "title": "發放設定",
      "size": "md",
      "centered": ""
    },
    on: {
      "ok": _vm.handleEdit
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.closeEditQuantity();
            }
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認送出 ")])];
      }
    }])
  }, [_c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleEdit.apply(null, arguments);
      }
    }
  }, [_c('div', [_vm._v(" 有效期間： ")]), _c('b-form-radio-group', {
    attrs: {
      "stacked": "",
      "name": "dateline_type"
    },
    model: {
      value: _vm.selectedOption,
      callback: function callback($$v) {
        _vm.selectedOption = $$v;
      },
      expression: "selectedOption"
    }
  }, [_c('div', {
    staticClass: "custom-radio-wrapper"
  }, [_c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 0
    }
  }, [_vm._v(" 自定日期區間 ")]), _c('DateSearchPicker', {
    staticClass: "ml-md-4 mr-md-2",
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間",
      "disabled": _vm.selectedOption !== 0
    },
    on: {
      "input": function input($event) {
        return _vm.handleDateChange($event);
      }
    },
    model: {
      value: _vm.dateBetween,
      callback: function callback($$v) {
        _vm.dateBetween = $$v;
      },
      expression: "dateBetween"
    }
  })], 1), _c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 1
    }
  }, [_vm._v(" 依日期區間推算 "), _c('div', [_vm._v("領取後幾日可以使用(0為當日)：")]), _c('b-form-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "start_days_after_take",
      "disabled": _vm.selectedOption !== 1,
      "placeholder": "請輸入數量"
    },
    model: {
      value: _vm.start_days_after_take,
      callback: function callback($$v) {
        _vm.start_days_after_take = $$v;
      },
      expression: "start_days_after_take"
    }
  })], 1), _c('div', [_vm._v("領取後幾日內有效(0為當日需使用完畢)：")]), _c('b-form-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "end_days_after_take",
      "disabled": _vm.selectedOption !== 1,
      "placeholder": "請輸入數量"
    },
    model: {
      value: _vm.end_days_after_take,
      callback: function callback($$v) {
        _vm.end_days_after_take = $$v;
      },
      expression: "end_days_after_take"
    }
  })], 1)], 1), _c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 2
    }
  }, [_vm._v("與優惠券的領取期限相同")]), _c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 3
    }
  }, [_vm._v("與此權益卡期限相同")]), _c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 4
    }
  }, [_vm._v("與會員會籍期限相同")]), _c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 5
    }
  }, [_vm._v("每月到期(當月1日起)")]), _c('b-form-radio', {
    staticClass: "custom-radio",
    attrs: {
      "value": 6
    }
  }, [_vm._v("每月到期(自會籍起始日起)")])], 1), _c('div', [_vm._v(" 發放數量： ")]), _c('b-form-group', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "padding-top": "10px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.selectedOption == 5 || _vm.selectedOption == 6,
      expression: "selectedOption == 5 || selectedOption == 6"
    }],
    staticClass: "mr-2 mb-2"
  }, [_vm._v("每月")]), _c('b-form-input', {
    staticClass: "col-8 mb-2 mr-sm-1",
    attrs: {
      "id": "name",
      "placeholder": "請輸入數量"
    },
    model: {
      value: _vm.coupon.quantity,
      callback: function callback($$v) {
        _vm.$set(_vm.coupon, "quantity", $$v);
      },
      expression: "coupon.quantity"
    }
  }), _c('div', {
    staticClass: "col-2 mb-2"
  }, [_vm._v("張")])], 1)])], 1)])], 1), [_c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-2 ml-5",
    attrs: {
      "variant": "danger",
      "size": "sm"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" 取消 ")]), _c('b-button', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.submitBenefitSetting
    }
  }, [_vm._v(" 儲存 ")])], 1)])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }